import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { setLoginInfo } from "redux/Actions";
import { ILoginData } from "types/Login";
import { postLogin } from "../requests/Login";

export function useMutationLogin() {

    const dispatch = useDispatch();

    const query = useMutation(postLogin, {
        onSuccess: (data) => {
            if(data?.success) {
                let loginInfo: ILoginData = data?.data;
                localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
                localStorage.setItem('tokenKey', data?.data?.currentSessionInfo?.access_token);
                dispatch(setLoginInfo(loginInfo));
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            // console.error(data)
        }
    });
    return query;
}
